/**
 * Vendor actions
 */
import Constants from '../../constants';

const { Vendor, User } = Constants;

/**
 * Action object dispatched to fetch users
 *
 * @param {object} params query params
 */
const fetchUsers = (params) => ({
  type: User.GET_USERS,
  params,
});

/**
 * Action object dispatched when unable to fetch users
 *
 * @param {object} error error object
 */
const fetchUsersError = (error) => ({
  type: User.GET_USERS_ERROR,
  error,
});

/**
 * Action object dispatched when users are fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {object} users: all fetched vendors
 *   @property {string} count: total count of users that match the request query
 * }
 */
const fetchUsersSuccess = ({ users, count }) => ({
  type: User.GET_USERS_SUCCESS,
  users,
  count,
});

/**
 * Action object dispatched to fetch vendors
 *
 * @param {object} params query params
 */
const fetchVendors = (params) => ({
  type: Vendor.GET_VENDORS,
  params,
});

/**
 * Action object dispatched when unable to fetch vendors
 *
 * @param {object} error error object
 */
const fetchVendorsError = (error) => ({
  type: Vendor.GET_VENDORS_ERROR,
  error,
});

/**
 * Action object dispatched when vendors are fetched successfully
 *
 * @param {object} action:
 * {
 *   @property {object} users: all fetched vendors
 *   @property {string} count: total count of users that match the request query
 * }
 */
const fetchVendorsSuccess = ({ rows: vendors, count }) => ({
  type: Vendor.GET_VENDORS_SUCCESS,
  vendors,
  count,
});

/**
 * Action object dispatched to update vendor password
 *
 * @param {object} vendor vendor data object
 */
const updateUser = (user) => ({
  type: User.UPDATE_USER,
  user,
});

/**
 * Action object dispatched if unable to update vendor password
 *
 * @param {object} error error object
 */
const updateUserError = (error) => ({
  type: User.UPDATE_USER_ERROR,
  error,
});

/**
 * Action object dispatched if vendor password is updated successfully
 *
 * @param {object} vendor vendor object
 */
const updateUserSuccess = ({ user }) => ({
  type: User.UPDATE_USER_SUCCESS,
  user,
});

export default {
  fetchUsers,
  fetchUsersError,
  fetchUsersSuccess,
  fetchVendors,
  fetchVendorsError,
  fetchVendorsSuccess,
  updateUser,
  updateUserError,
  updateUserSuccess,
};
